import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatError } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { UploadShapefileComponent } from '../../../../shared/components/upload-shapefile/upload-shapefile.component';
import { SmartOrpcClientService } from '../../../../shared/services/smart-orpc-client.service';
import { EnhancedLoadingService } from '../../../../shared/services/enhanced-loading.service';
import { SnackbarService } from '../../../../shared/services/snackbar.service';

@Component({
  selector: 'app-monitoring-safras-upload',
  standalone: true,
  imports: [
    CommonModule,
    MatError,
    MatIconModule,
    MatButtonModule,
    UploadShapefileComponent,
    MatProgressSpinnerModule,
  ],
  templateUrl: './monitoring-safras-upload.component.html',
  styleUrl: './monitoring-safras-upload.component.scss',
})
export class MonitoringSafrasUploadComponent implements OnInit {
  @ViewChild(UploadShapefileComponent)
  declare fileComponent: UploadShapefileComponent;

  isValid = signal<boolean | null>(null);
  loadingService = inject(EnhancedLoadingService);
  isLoading = this.loadingService.button$;
  private snackBar = inject(SnackbarService);

  onFileUploaded($event: string | null) {
    if (this.id && $event) {
      this.selectedFile = $event;
      this.isValid.set(null);

      // Valida o arquivo para monitoring-safras
      this.orpc.client.monitoring.fileValidation
        .validateFileReplacement({
          fileName: $event,
          requestId: this.id,
        })
        .then(({ isValid }) => {
          this.isValid.set(isValid);
        })
        .finally(() => {
          this.loadingService.hide();
        });
    }
  }

  selectedFile: string | null = null;
  originalFileName: string | null = null;
  id: number | null = null;

  orpc = inject(SmartOrpcClientService);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.id = parseInt(this.route.snapshot.paramMap.get('id') ?? '0');
  }

  onOriginalFileName(name: string | null) {
    this.originalFileName = name;
  }

  async onSubmit() {
    if (this.isValid() == false) return;
    this.fileComponent.fileCtrl.markAllAsTouched();
    if (this.fileComponent.fileCtrl.invalid) {
      return;
    }
    if (!this.selectedFile) {
      alert('Selecione um arquivo primeiro!');
      return;
    }
    if (!this.id) {
      alert('Não foi possível identificar a solicitação.');
      return;
    }

    this.loadingService.show();

    try {
      // Cria a validação de arquivo para monitoring-safras
      const result = await this.orpc.client.monitoring.fileValidation.create({
        requestId: this.id,
        gcsFileName: this.selectedFile,
        originalFileName: this.originalFileName ?? undefined,
      });

      console.log('Validação de arquivo criada:', result);
      this.snackBar.alert(
        `Upload realizado com sucesso para solicitação ${this.id}! ID da validação: ${result.fileValidationId}`,
        -1,
      );
      this.navigateToDetailScreen();
    } finally {
      this.loadingService.hide();
    }
  }

  onCancel() {
    this.navigateToDetailScreen();
  }

  private navigateToDetailScreen() {
    this.router.navigate(['monitoring-safras/adm/detail/' + this.id]);
  }
}
